<template>
  <div class="nuttrema-layout-cred">
    <slot name="overflow"></slot>
    <div class="nuttrema-layout-cred__central">
      <slot name="west"></slot>
      <slot name="content"></slot>
      <slot name="east"></slot>
    </div>
    <!-- end ~ nuttrema-layout-cred__central -->
  </div>
  <!-- end ~ nuttrema-layout-cred -->
</template>

<script>
export default {
  name: 'nuttrema-layout-cred',
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-layout-cred {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    align-self: stretch;

    .nuttrema-layout-cred__central {
      flex-grow: 1;
      display: flex;
      overflow: hidden;
      position: relative;
      // border-radius: 5px;
      align-self: stretch;
      // margin: 0.5em 0.75em;
      transition: all 0.10s;
      background-color: #fff;
      // border: 2px solid #DBE2EF;

      .nuttrema-layout-cred__west {
        align-self: stretch;
        display: flex;
        flex: 0 0 280px;
        flex-direction: column;
        background-color: #fcfcfc;
        border-top-left-radius: 5px;
        justify-content: space-between;
        border-bottom-left-radius: 5px;
        border-right: 2px solid #dbe2ef;

        &.nuttrema-layout-cred__west--orange {
          background-color: $nutrition-facts-orange-light-bg;
          border-right: 1px solid $nutrition-facts-orange-light-border;
        }

        .nuttrema-layout-cred__top {
          align-self: stretch;
        }

        .nuttrema-layout-cred__center {
          flex-grow: 1;
          overflow-y: auto;
          align-self: stretch;
        }

        .nuttrema-layout-cred__bottom {
          display: flex;
          padding: 0.75em;
          min-height: 4.5em;
          align-self: stretch;
          align-items: center;
        }
      }

      .menu--nuttrema-layout-cred {
        margin: 1.5em;
      }

      .nuttrema-layout-cred__content {
        flex-grow: 1;
        display: flex;
        overflow: hidden;
        align-self: stretch;
      }
    }
    // end ~ nuttrema-layout-cred__central

    .nuttrema-layout-cred__east {
      align-self: stretch;
      border-right: 0;
      flex: 0 0 320px;
      overflow: hidden;
      border-radius: 5px;
      position: relative;
      background-color: #fff;
      margin: 0.5em 0 0.5em 0;
      border: 2px solid #DBE2EF;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .nuttrema-theme-professional-topography & {
      .nuttrema-layout-cred__central {
        margin: 0;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-cred.vue